export enum EnumScopes {
    User = 'User',
    Managed = 'Managed',
    Application = 'Application',
    System = 'System',
}
